import { fromEvent, Observable } from 'rxjs';
import { map, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';

const menuToggleOptions = [
    {
        el: $(".menu-trigger, .top, body, .menu"),
        class: 'active'
    }
];

let pageSections = getSections($(".menu__link"));

const winResize = fromEvent($(window), 'resize')
    .subscribe(e => {
        pageSections = getSections($(".menu__link"));
    });

const scrollDirection$ = new Observable(subscriber => {
      let lastScroll = 0;
      window.addEventListener('scroll', function() {
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value

        if (currentScroll > 0 && lastScroll <= currentScroll){
          lastScroll = currentScroll;
          // вызываем событие 'down' для всех подписчиков
          subscriber.next('down');
        } else {
          lastScroll = currentScroll;
          // вызываем событие 'up' для всех подписчиков
          subscriber.next('up');
        }
      });
});

scrollDirection$
    .pipe(distinctUntilChanged())
    .pipe(debounceTime(100))
    .subscribe(direction => {
        $('.top').stop().removeClass('down up').addClass(direction);
    });


const winScroll$ = fromEvent($(window), 'scroll')
    .pipe(debounceTime(500))
    .pipe(map(e => {
        return {
            scrollTop: $(window).scrollTop()
        }
    }))
    .subscribe(data => {
        $('.scrollup')[data.scrollTop > 1400 ? 'fadeIn' : 'fadeOut']();
        $('.top')[data.scrollTop < 20 ? 'addClass' : 'removeClass']('fixed');

        const $curSec = pageSections.find(section => {
            return isVisible(data.scrollTop, section.top, section.bottom);
        });

        if(typeof $curSec === 'object' && $($curSec.id).length) {
            checkLink($(`.menu__link[data-href="${ $curSec.id }"]`));
            setHash($curSec.id);
        }
    });

const toggleMenu$ = fromEvent($(".menu-trigger"), 'click')
    .pipe(map(e => window.innerWidth))
    .subscribe(winWidth => {
        if(winWidth <= 780) {
            if(!$('.menu').hasClass('smallform')) {
                toggleClass(menuToggleOptions, $(".menu-trigger").hasClass('active'));
            } else {
                $(".open-menu").click();
            }
        } else {
            toggleClass(menuToggleOptions, $(".menu-trigger").hasClass('active'));
        }
    });

const scrollTop$ = fromEvent($('.scrollup'), 'click')
    .pipe(tap(e => e.preventDefault()))
    .subscribe(e => {
        $("html, body").animate({
            scrollTop: 0
        }, 500);
    });

const menu$ = fromEvent($(".menu__link"), 'click')
    .pipe(tap(e => {
        if($($(e.target).data('href')).length) {
            e.preventDefault();
        }
    }))
    .pipe(map(e => $(e.target)))
    .subscribe($link => {
        if($($link.data('href')).length) {
            checkLink($link);
            toggleClass(menuToggleOptions, $(".menu-trigger").hasClass('active'));
            scrollTo($($link.data('href')));
        }
    });

const anchors$ = fromEvent($(".open-menu"), 'click')
    .pipe(map(e => window.innerWidth))
    .subscribe(winWidth => {
        if(winWidth <= 780) {
            toggleClass([
                {
                    el: $(".menu"),
                    class: 'smallform'
                },
                {
                    el: $('body, .menu-trigger'),
                    class: 'active'
                }
            ], $(".menu-trigger").hasClass('active'));
        } else {
            toggleClass(menuToggleOptions, $(".menu-trigger").hasClass('active'));
        }
    });

function getSections($navLinks) {
    let result = [];

    $navLinks.each(function () {
        const hash = $(this).data("href") || '#home';

        if($(hash).length) {
            const section = {
                    id: hash,
                    top: Math.round($(hash).offset().top),
                    bottom: Math.round($(hash).offset().top + $(hash).innerHeight()),
                };
            result.push(section);
        }
            
    });

    return result;

}

function checkLink($link) {
    $(".menu__link.active").removeClass("active");
    $link.addClass("active");
}

function scrollTo($el) {
    $("html, body").stop().animate({
        scrollTop: $el.offset().top - $('.top').innerHeight()
    }, 500);
}

function toggleClass(options, isClose) {
    options.forEach(item => {
        item.el[isClose ? 'removeClass' : 'addClass'](item.class);
    });
}

function setHash(hash) {
    history.pushState({
        param: 'value'
    }, '', hash);
}

function isVisible(scrollTop, top, bottom) {
    return scrollTop >= top && scrollTop < bottom;
}